import { marked } from 'marked';

marked.setOptions({ gfm: true, breaks: true });

/**
 * Insere `\n\n` faltantes que LLMs costumam economizar no streaming:
 * — antes de headers `##`, `###` que aparecem colados ao texto anterior;
 * — antes de bullets `- ` / numbered list `1.` no meio de um parágrafo;
 * — antes de "linha de label" tipo `**Status:**` quando vêm logo após texto.
 * Idempotente: rodar duas vezes não muda o resultado.
 */
function normalizeMarkdown(s: string): string {
  return s
    // header colado: "foo## Bar" → "foo\n\n## Bar"
    .replace(/([^\n])(#{1,6}\s)/g, '$1\n\n$2')
    // header com 1 newline só: "foo\n## Bar" → "foo\n\n## Bar"
    .replace(/([^\n])\n(#{1,6}\s)/g, '$1\n\n$2')
    // bullet colado: "foo- bar" → "foo\n- bar" (somente quando " - " parece início de item, evita confundir com hífen no meio de palavra)
    .replace(/([.!?:])\n(- |\* |\d+\. )/g, '$1\n\n$2')
    // bold-label colado: "foo**Status:**" → "foo\n\n**Status:**"
    .replace(/([.!?])(\*\*[^*\n]{1,40}\*\*:)/g, '$1\n\n$2');
}

export function Markdown({ content }: { content: string }) {
  const normalized = normalizeMarkdown(content || '');
  const html = marked.parse(normalized, { async: false }) as string;
  return <div class="prose-msg" dangerouslySetInnerHTML={{ __html: html }} />;
}
